import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import frCommon from '../locales/fr/common.json';
import enCommon from '../locales/en/common.json';

const STORAGE_KEY = 'entrea_i18n_language';

function setHtmlLang(lng) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng === 'en' ? 'en' : 'fr';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: frCommon },
      en: { common: enCommon },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    defaultNS: 'common',
    ns: ['common'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY,
    },
    interpolation: { escapeValue: false },
  });

setHtmlLang(i18n.resolvedLanguage || i18n.language || 'fr');
i18n.on('languageChanged', (lng) => {
  setHtmlLang(lng);
});

export default i18n;
export { STORAGE_KEY };
